import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LOCAL_STORAGE_KEYS } from 'src/app/shared/constants/storage-keys';

@Component({
    selector: 'tdms-analysis-find-content',
    templateUrl: './analysis-find-content.component.html',
    styleUrls: ['./analysis-find-content.component.scss'],
    standalone: false
})
export class AnalysisFindContentComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  submitSearch(searchTerm: string) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.SEARCH_TERM, searchTerm);
    this.clearStorage();
    this.router.navigate(['analysis/refinecontent']);
  }

  private clearStorage(){
      const clearKeys:string[] = [
        LOCAL_STORAGE_KEYS.V_DOC_COUNT,
        LOCAL_STORAGE_KEYS.VS_REQ,
        LOCAL_STORAGE_KEYS.V_PUB_LIST,
        LOCAL_STORAGE_KEYS.V_PUB_FILTERS,
        LOCAL_STORAGE_KEYS.PUB_FACETS,
        LOCAL_STORAGE_KEYS.FROM_DATE,
        LOCAL_STORAGE_KEYS.TO_DATE,
        LOCAL_STORAGE_KEYS.DOC_FILTERS,
        LOCAL_STORAGE_KEYS.FULL_TEXT_LIMITER,
        LOCAL_STORAGE_KEYS.SOURCE_FILTERS,
      ];
	    clearKeys.forEach(key => {
	      localStorage.removeItem(key);
	    })
	  }
}
